exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{\n  margin-top : 5%;\n  padding : 0;\n}\n\ntable, th, td{\n  border: 1px solid black;\n  text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/proficiency-table/proficiency-table.component.css
// module id = ../../../../../src/app/components/proficiency-table/proficiency-table.component.css
// module chunks = main